<template>
  <div class="mult-input-show">
    <template v-for="(item, index) in list">
      <div class="mult-item" :key="index">
        <!-- 文本 -->
        <div class="text" v-if="item.type === 'text' && item.content">{{ item.content }}</div>

        <!-- 文本 -->
        <div class="text" v-else-if="item.type === 'aitext' && item.content">{{ item.content }}</div>

        <!-- 图片 -->
        <!-- lazy-load -->
        <div class="img flex-center" v-else-if="item.type === 'image'">
          <van-image class="vimg" fit="scale-down" alt="" :src="item.url" @click="prewImage(item)">
            <template v-slot:loading>
              <van-loading type="circular" vertical size="20">加载中...</van-loading>
            </template>
          </van-image>
        </div>

        <!-- 视频展示 这个是预留的功能，暂时还没有上 -->
        <div
          class="video flex-center"
          v-else-if="item.type === 'video'"
          @click="app.module.video.play(item.url)"
        >
          <van-image class="vimg" fit="cover" alt="" :src="getVideoThumbUrl(item)">
            <template v-slot:loading>
              <van-loading type="circular" vertical size="20">加载中...</van-loading>
            </template>
          </van-image>
          <div class="pay-icon-warp">
            <!-- <van-icon class-prefix="vxs-icon" name="shipin" size="75" color="#FFF" /> -->
            <div class="to-play-icon"></div>
            <div class="downbtn" @click.stop="downVideo(item)">下载视频</div>
          </div>
        </div>

        <!-- 精彩瞬间展示 西瓜视频 -->
        <template v-else-if="item.type === 'moment'">
          <!-- status: 1合成中，2合成成功，3合成失败 -->
          <!-- 已经有视频的url地址 -->
          <div
            v-if="item.url || item.status == 2"
            class="video flex-center"
            @click="app.module.video.play(item.url)"
          >
            <van-image class="vimg" fit="cover" alt="" :src="getVideoThumbUrl(item)">
              <template v-slot:loading>
                <van-loading type="circular" vertical size="20">加载中...</van-loading>
              </template>
            </van-image>
            <div class="pay-icon-warp">
              <!-- <van-icon class-prefix="vxs-icon" name="shipin" size="75" color="#FFF" /> -->
              <div class="to-play-icon"></div>
              <div class="downbtn" @click.stop="downVideo(item)">下载视频</div>
            </div>
          </div>
          <!-- 一键生成视频or合成中视频 -->
          <div class="video-default" v-else-if="item.status == 1">
            <div class="txt flex-center"><van-loading color="var(--c1)" size="18"/>视频合成中...</div>
          </div>
          <!-- 一键生成视频or合成中视频：合成失败 -->
          <div class="video-default" v-else-if="item.status == 3">
            <img class="error-img" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"/>
            <p class="error-tips">视频合成失败</p>
          </div>
        </template>

        <multimedia-record v-else-if="item.type === 'audio'" :record="item"></multimedia-record>
      </div>
    </template>
  </div>
</template>

<script>
import MultimediaRecord from './child/multimedia-record.vue';

export default {
  name: 'vx-multInputShow',
  components: {
    MultimediaRecord,
  },
  props: {
    //   接一传入数据
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    prewImage(item) {
      const urls = this.list.filter(item => item.type === 'image').map(item => item.url);
      const index = urls.findIndex(url => url === item.url);
      vant.ImagePreview({
        startPosition: index,
        images: urls,
      });
    },
    // 获取视频封面图
    getVideoThumbUrl(item) {
      // 老的数据是FilePath,改版后统一成Url;
      return item.thumburl || `${item.url}?x-oss-process=video/snapshot,t_1,f_jpg,w_1000,ar_auto`;
    },
    async downVideo(item) {
      let url=item.url
      if (app.base.env == 'xgj') {
        app.sdk.downloadVideo({
          data: url
        })
      } else {
        this.downVideo_H5(item)
      }
    },
    async downVideo_H5(item) {
      // item.url='https://cdn03.xiaogj.com/x3_file2/video/20260115/169125/x3_other/ba9f7f2802a0414391179b647722d906/1768482802369.mp4';
      // item.name='1761900254166.mp4';
      let url=item.url;
      try {
        let msg = ''
        if (app.base.env == 'wx' && app.base.isMobile == true) {
          if(app.base.isIos) {
            msg = `因苹果手机系统上微信APP的限制，无法直接下载视频到手机相册。\n目前只能通过系统浏览器“Safari”下载到“文件”，请先点击“复制地址”按钮，然后点击帮助链接：<a href="https://bangzhu.xiaogj.com/yxhelp-list/detail-148.html">https://bangzhu.xiaogj.com/yxhelp-list/detail-148.html</a>\n查看具体操作方法。`
          } else {
            msg = '因微信限制，请复制视频地址，使用浏览器打开下载'
          }
        } else {
          msg = '点击下方“复制地址”按钮，在浏览器打开下载。'
        }
        await vant.Dialog.confirm({
          title: '提示',
          message: msg,
          messageAlign: 'left',
          confirmButtonText: '复制地址',
          beforeClose: async (action, done) => {
            if (action !== 'confirm') {
              done();
              return;
            }

            // 当用户点击复制地址时：先调用后端生成临时token，再拼接 simple 下的 file-download 页面地址并复制
            try {
              // 说明/假设：token 接口位于 /cs-edu/fileDownload/h5-link，接收 JSON { fileName, fileUrl }
              // 如果实际接口路径不同，请调整为后端实际接口。
              const payload = {
                fileName: item.name,
                fileUrl: url,
              };

              const res = await app.http.ajax({
                method: 'post',
                url: '/cs-edu/public/fileDownload/h5-link',
                params: payload,
              });
              // const res={code:200,data:'2312321321321312'}
              console.log(res)
              
              let token='';
              if(res&&res.code===200){
                token=res.data
              }
              if (!token) {
                // 如果后端未返回token，回退到复制原始url，给出提示
                vant.Toast('未获取到下载地址');
                done();
                return;
              }

              // 组装跳转到 simple 的 file-download 页面 URL
              // 约定路径：/app/simple/#/share/file-download?token=...  （若实际路由不同可调整）
              const simplePath = `${location.origin}/app/simple/#/file-download?token=${encodeURIComponent(token)}`;

              // copy 到剪贴板
              app.tool.copy(simplePath);

              // 完成但不关闭 dialog 在 iOS 微信环境下，保持原有行为
              if (app.base.env == 'wx' && app.base.isMobile == true && app.base.isIos) {
                done(false);
              } else {
                done();
              }
            } catch (err) {
              console.error('生成下载token失败', err);
              vant.Toast('生成下载地址失败');
              done();
            }
          }
        });
      } catch (error) {}
    }
  },
};
</script>

<style lang="scss" scoped>
.mult-input-show {
  width: 100%;

  .mult-item {
    position: relative;
    padding-top: calc(var(--gap) * 8);
    padding-bottom: calc(var(--gap) * 8);

    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      padding-bottom: 0;
    }

    .text {
      padding: 0;
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g8);
      background: transparent;
      white-space: pre-wrap;
      overflow-wrap: break-word;
    }
    .img {
      text-align: center;
      background: var(--g1);
      border-radius: 5px;
      overflow: hidden;
    }
    .video {
      position: relative;
      text-align: center;
      background: var(--g1);
      border-radius: 5px;
      overflow: hidden;
      width: 100%;
      height: 0;
      padding-top: 56.25%;
      .vimg {
        position: absolute;
        width: 100%;
        top: 0;
        bottom: 0;
      }
      .pay-icon-warp {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.3);
        .downbtn {
          position: absolute;
          bottom: calc(var(--gap) * 4);
          right: calc(var(--gap) * 4);
          padding: calc(var(--gap) * 2) calc(var(--gap) * 6);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: rgba(var(--white-rgb), 0.8);
          border: 1px solid rgba(var(--white-rgb), 0.6);
          border-radius: 4px;
        }
        .to-play-icon {
          width: calc(var(--gap) * 40);
          height: calc(var(--gap) * 40);
        }
      }
    }
    .video-default {
      border-radius: 5px;
      background: var(--g1);
      text-align: center;
      padding: calc(var(--gap) * 70) 0;
      .txt {
        font-size:var(--fs-lg);
        line-height:var(--lh-lg);
        color: var(--c1);
        .van-loading {
          margin-right: calc(var(--gap) * 8);
        }
      }
      .error-img {
        width: calc(var(--gap) * 128);
        height: calc(var(--gap) * 128);
      }
      .error-tips {
        color: var(--g6);
      }
    }
  }
}
</style>
